import { Stack } from "@mui/material";
import HelpButton from "../HelpButton";
import SimpleParagraphs from "./commons/SimpleParagraphs";

export default function MorningLightHelpDialog() {
  return (
    <HelpButton dialogTitle="朝の光">
      <Stack sx={{ gap: 6 }}>
        <SimpleParagraphs
          paragraphs={[
            {
              title: "睡眠への影響",
              content:
                "人間の体内時計は24時間より少し長い周期で動いており、地球の24時間サイクルと合わせるためにリセットが必要です。朝の太陽光を浴びることがこのリセットに最も効果的であり、夜のスムーズな入眠を助けます。",
            },
            {
              title: "おすすめ",
              content:
                "起床後は太陽の光を浴びましょう。外に出て浴びることが望ましいですが、難しければ窓際でカーテンを開けるだけでも十分効果的です。具体的には、2,500ルクス以上の光で体内時計はリセットされますが、晴れた日の太陽光は100,000ルクス、曇りの日でも10,000ルクスあります。窓越しの日光浴だと曇りの日で2,500ルクス程度なので、少なくともカーテンを開けて光を浴びることが必要になります。逆に、室内の蛍光灯は明るく感じますが、実は通常のオフィスで500ルクス程度しかなく、住宅の室内はさらに暗くなるので体内時計のリセットには不十分となります。",
            },
          ]}
        />
      </Stack>
    </HelpButton>
  );
}
